import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
  <path d="M5.00282 5.74817C5.1007 5.74817 5.19104 5.73123 5.27386 5.69735C5.35667 5.65971 5.43572 5.60324 5.51101 5.52795L9.81366 1.12931C9.93789 1.00132 10 0.846984 10 0.666295C10 0.542071 9.96989 0.431023 9.90966 0.33315C9.85319 0.231512 9.77602 0.150579 9.67815 0.0903492C9.58027 0.0301194 9.46923 4.76837e-06 9.345 4.76837e-06C9.16808 4.76837e-06 9.00998 0.0696454 8.87069 0.208926L5.00282 4.17279L1.13495 0.208926C0.995671 0.0696454 0.835686 4.76837e-06 0.654997 4.76837e-06C0.534538 4.76837e-06 0.425372 0.0301194 0.327498 0.0903492C0.225862 0.150579 0.14681 0.231512 0.0903444 0.33315C0.0301151 0.431023 0 0.542071 0 0.666295C0 0.846984 0.0639944 1.00132 0.191982 1.12931L4.49464 5.52795C4.56992 5.60324 4.64897 5.65971 4.73179 5.69735C4.81461 5.73123 4.90495 5.74817 5.00282 5.74817Z" />
</svg>
`;

export const ChevronDown = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
